import Swal from "sweetalert2";

export const showAlert = (action, item) => {
  let icon = action === "error" ? "error" : "success";
  let text =
    action === "error"
      ? `${item} failed`
      : `${item} has been ${action} successfully.`;
  Swal.fire({
    icon: icon,
    text: text,
    showConfirmButton: false,
    timer: 3000,
  });
};
